import * as React from "react";

import "./selective-office-select.scss";

import {sortMulti}        from "@Common/utils/collections";
import {chain}            from "@Common/utils/fs";
import {SearchableSelect} from "@Common/ui-components/searchable-select/searchable-select";
import {xdQAAttribute}    from "../analytics-layout";

const OFFICE_FIELDS = [
    "branchAddress1",
    "branchAddress2",
    "branchCity",
    "branchState",
    "branchZip",
]

export const SelectiveOfficeSelect = ({offices, idBranch, idAgent, setFilters, isInternalUser=false}) => {
    const officeFieldsSearchable = OFFICE_FIELDS.slice(0)
    officeFieldsSearchable.push("branchName")
    if(isInternalUser) {
        officeFieldsSearchable.push("idBranch")
    }

    return (
        <div className="selective-office-select-dznts38">
            {
                SearchableSelect({
                    list: offices,
                    disabled: !Array.isArray(offices) || offices.length < 1,
                    getLabel: (office) => chain(
                        office.branchName,
                        (name) => {
                            return (
                                <span
                                    title={name}
                                    {...xdQAAttribute('dropdown_item', `Office ${name}`)}
                                >
                                    {name}
                                </span>
                            )
                        }
                    ),
                    placeholder: "Please select an office",
                    onSelect: (office) => {
                        setFilters([])
                        idAgent.onChange(null)
                        if (office.idBranch === "Company Order") {
                            idAgent.onChange(office.idBranch)
                        }
                        idBranch.onChange(office.idBranch)
                    },
                    isSelected: (office) => office.idBranch === idBranch.value,
                    getSublabel: (office) => {
                        return (
                            <div {...xdQAAttribute('dropdown_item', `Office ${office.idBranch}`)}>
                                {OFFICE_FIELDS.map(field => office[field]).filter(Boolean).join(", ")}
                                {isInternalUser && `| Internal ID: ${office.idBranch}`}
                            </div>
                        )
                    },
                    mapSearchAsItemFilter: (search) => {
                        const searchLowercase = search.toLowerCase()
                        return (office) => officeFieldsSearchable.some(
                                    field => office[field]?.toLowerCase().includes(searchLowercase)
                                )
                    },
                    xdQaName: "Office",
                })
            }
        </div>
    )
}